import { render, staticRenderFns } from "./CardMenuList.vue?vue&type=template&id=68ac0946"
import script from "./CardMenuList.vue?vue&type=script&lang=js"
export * from "./CardMenuList.vue?vue&type=script&lang=js"
import style0 from "./CardMenuList.vue?vue&type=style&index=0&id=68ac0946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports